export const COLOR_MAP = [
    "#E53935",
    "#1E88E5",
    "#43A047",
    "#FB8C00",
    "#8E24AA",
    "#00ACC1",
    "#FDD835",
    "#6D4C41",
    "#D81B60",
    "#3949AB",
    "#7CB342",
    "#F4511E",
    "#00897B",
    "#5E35B1",
    "#C0CA33",
    "#EC407A",
    "#039BE5",
    "#EF6C00",
    "#2E7D32",
    "#C62828",
    "#7B1FA2",
    "#00838F",
    "#FFB300",
    "#5D4037",
    "#1565C0",
    "#AD1457",
    "#9E9D24",
    "#BF360C",
    "#4527A0",
    "#00695C",
];
